module.exports = __webpack_public_path__ + "img/egg_clouds.92f2d89b.svg";